module.exports = __webpack_public_path__ + "prod/1.42.2/img/serve-two.526088af.png";